import { render, staticRenderFns } from "./gzhTemplate.vue?vue&type=template&id=3cf636f8&scoped=true"
import script from "./gzhTemplate.vue?vue&type=script&lang=js"
export * from "./gzhTemplate.vue?vue&type=script&lang=js"
import style0 from "./gzhTemplate.vue?vue&type=style&index=0&id=3cf636f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf636f8",
  null
  
)

export default component.exports